(function () {
  'use strict';
  var node = document.getElementById('oc-offer-policy');
  if (!node) return;
  var config = JSON.parse(node.textContent), eligible = new Set(config.eligible), excluded = new Set(config.excluded);
  window.ocOfferPolicy = {
    text: config.text,
    eligible: function (id) { return true; },
    excluded: function (id) { return false; },
    count: function (cart) { return cart ? cart.items.reduce(function (n, item) { return n + item.quantity; }, 0) : null; },
    progress: function (count) { return count === null ? config.text.loading : (count >= 3 ? config.text.qualified : config.text.remaining).replace('__COUNT__', count >= 3 ? count : 3 - count); }
  };
}());
